export function regexPassword (value) {
  return /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/.test(value)
}
